<template>
  <dialog-default
    :open="true"
    width="90%"
    top="100px"
    :show-close="false"
    :modal-append-to-body="false"
    :append-to-body="true"
    :destroy-on-close="true"
    customClass="corrigir"
    hidden-title
  >
    <TemplateSolicitacao
      v-if="idTemplate"
      :id-template="idTemplate"
      :titulo="tituloNavegacao"
      :id-funcionalidade="funcionalidade.idFuncionalidade"
      :id-tipo-ocorrencia="idTipoOcorrencia"
      :custom-cancelar="customCancelar"
      :custom-finalizar="customFinalizar"
      :custom-voltar="customVoltar"
    />
  </dialog-default>
</template>

<script>
import TemplateSolicitacao from '@/components/TemplateSolicitacao/TemplateSolicitacao'
import { mapState } from 'vuex'
import DialogDefault from '@/components/DialogDefault/DialogDefault.vue'

export default {
  name: 'Func4Corrigir',
  components: { DialogDefault, TemplateSolicitacao },
  props: {
    customVoltar: { type: Function },
    customCancelar: { type: Function },
    customFinalizar: { type: Function }
  },
  computed: {
    ...mapState('SetupApp', ['funcionalidade']),
    tituloNavegacao () {
      return this.funcionalidade.parametros.dashboard.nome
    },
    idTemplate () {
      return this.funcionalidade.parametros.idTemplateSolicitacao
    },
    idTipoOcorrencia () {
      return this.funcionalidade.parametros.idTipoOcorrencia
    }
  }
}
</script>
